import {EyeInvisibleOutlined, EyeOutlined} from '@ant-design/icons';
import cn from 'classnames';
import React, {forwardRef, useState} from 'react';

import {PASSWORD_HIDE, PASSWORD_SHOW} from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';

const PasswordInput = forwardRef(({className, disabled, onPressEnter, onKeyDown, ...inputProps}, ref) => {
    const [isVisible, setIsVisible] = useState(false);
    const localizedStrings = getLocalizedStrings();
    const toggleLabel = localizedStrings[isVisible ? PASSWORD_HIDE : PASSWORD_SHOW];

    return (
        <span className={cn('ep-password-input', className)} data-disabled={disabled || undefined}>
            <input
                autoCapitalize='none'
                autoCorrect='off'
                spellCheck={false}
                {...inputProps}
                ref={ref}
                value={inputProps.value ?? ''}
                type={isVisible ? 'text' : 'password'}
                disabled={disabled}
                className='ep-password-input-field'
                onKeyDown={(event) => {
                    onKeyDown?.(event);
                    if (event.key === 'Enter' && !event.defaultPrevented) onPressEnter?.(event);
                }}
            />
            <button
                type='button'
                className='ep-password-input-toggle'
                disabled={disabled}
                aria-label={toggleLabel}
                aria-controls={inputProps.id}
                aria-pressed={isVisible}
                title={toggleLabel}
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => setIsVisible((visible) => !visible)}
            >
                {isVisible ? <EyeOutlined aria-hidden /> : <EyeInvisibleOutlined aria-hidden />}
            </button>
        </span>
    );
});

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
